import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import dayjs from "dayjs";

const Display = ({
  timeRange,
  selectedTime,
  handleButtonClick,
  nextDisable,
  previousDisable,
}) => {
  const startTime = new Date(timeRange?.[0]);
  const endTime = new Date(timeRange?.[1]);

  return (
    <div className="date flex-center">
      <Row gutter={[16, 16]}>
        <Col span={2} offset={1} className="flex-center">
          {previousDisable ? (
            <div>
              <LeftOutlined className="disabled" />
            </div>
          ) : (
            <div
              data-testid="prev-arrow"
              onClick={() => handleButtonClick(true)}
              className="cursor-pointer"
            >
              <LeftOutlined className="" />
            </div>
          )}
        </Col>
        <Col span={18} className="flex-center p0">
          <div className="days-picker-display-range">
            {selectedTime === "Hour"
              ? `${startTime.toLocaleTimeString([], {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })} - ${dayjs(endTime) > dayjs().subtract(1, "hour") ? "Now"  : endTime.toLocaleTimeString([], {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })}`
              : `${startTime.toLocaleString("default", {
                  month: "short",
                })} ${startTime.getDate()} - `+ (dayjs(endTime) > dayjs().subtract(1, "hour") ? "Now"  :  `${endTime.toLocaleString(
                  "default",
                  {
                    month: "short",
                  }
                )} ${endTime.getDate()}`)}
          </div>
        </Col>
        <Col span={2} className="flex-center">
          {nextDisable ? (
            <div>
              <RightOutlined className="f14 disabled" />
            </div>
          ) : (
            <div
              data-testid="next-arrow"
              onClick={() => handleButtonClick(false)}
              className="cursor-pointer"
            >
              <RightOutlined className="f14" />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default Display;
